<script>
export default {
    data() {
        return {
            file: null,
            caption: "",
            sendButtonDisabled: true,
        }
    },
    methods: {
        changeFileValue(e) {
            this.file = e.target.files[0]

            this.checkFileAndCaption()
        },
        changeCaptionValue(e) {
            this.caption = e.target.value

            this.checkFileAndCaption()
        },
        checkFileAndCaption() {
            if (this.file && this.caption.trim()) {
                this.sendButtonDisabled = false
            } else {
                this.sendButtonDisabled = true
            }
        },
    },
}
</script>

<template>
    <div
        class="d-flex justify-content-center align-items-center w-100 upload-chat-file-dialog"
    >
        <div class="bg-white rounded-lg p-3 w-50 shadow">
            <h3>Upload a File</h3>

            <form>
                <div class="custom-file mt-2">
                    <input
                        type="file"
                        class="custom-file-input"
                        id="inputGroupFile01"
                        aria-describedby="inputGroupFileAddon01"
                        @change="changeFileValue"
                        accept="image/*, video/*, .pdf"
                    />
                    <label class="custom-file-label" for="inputGroupFile01">
                        {{ file ? file.name : `Choose file` }}
                    </label>
                </div>
                <input
                    type="text"
                    class="form-control mt-1"
                    placeholder="Add a caption"
                    :value="caption"
                    @input="changeCaptionValue"
                />
                <div class="d-flex justify-content-between w-100 mt-4">
                    <button
                        @click="$emit('on-cancel-click')"
                        type="button"
                        class="btn btn-danger"
                    >
                        Cancel
                    </button>
                    <button
                        @click.prevent="$emit('on-send-click', file, caption)"
                        type="submit"
                        class="btn btn-primary"
                        :disabled="sendButtonDisabled"
                    >
                        Send
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>
<style>
.upload-chat-file-dialog {
    position: absolute;
    z-index: 1000;
    height: 85%;
}
</style>
